import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Bar } from 'src/app/models/bar';

export const setSelectedBar = createAction('[Bar] Set Selected Bar', props<{ selectedBar: Bar }>());

export const getBars = createAction('[Bar] Get Bars', props<{ bars: Bar[] }>());

export const deleteBar = createAction('[Bar] Delete Bar', props<{ bar: Bar }>());

export const deleteBarSuccess = createAction('[Bar] Delete Bar Success', props<{ deletedBar: Bar }>());

export const deleteBarError = createAction('[Bar] Delete Bar Error', props<{ err: HttpErrorResponse }>());
